import quickFetch from 'quick-fetch';
export const getQuickFetchOrMakeRequest = (name, makeRequest, successCondition) => {
  const earlyMetaRequest = quickFetch.getRequestStateByName(name);
  if (earlyMetaRequest) {
    return new Promise((resolve, reject) => {
      earlyMetaRequest.whenFinished(result => {
        if (!successCondition || successCondition(result)) {
          resolve(result);
        } else {
          makeRequest().then(resolve).catch(reject);
        }
        quickFetch.removeEarlyRequest(name);
      });
      earlyMetaRequest.onError(() => {
        // retry the request
        makeRequest().then(resolve).catch(reject);
        quickFetch.removeEarlyRequest(name);
      });
    });
  } else {
    return makeRequest();
  }
};